import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import { ESTATUS_AUTORIZADO } from 'utils/constants';

export const baseURI = 'nominas/solicitudes';

/**
 * GET Configuracion Solicitudes
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getConfiguracionSolicitudes = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Configuracion Solicitud
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getConfiguracionSolicitud = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Configuracion Solicitud
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postConfiguracionSolicitud = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Configuracion Solicitud
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchConfiguracionSolicitud = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Configuracion Solicitud
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteConfiguracionSolicitud = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Configuracion Solicitud a estatus AUTORIZADO
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const autorizarConfiguracionSolicitud = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, { estados_globales: ESTATUS_AUTORIZADO });
    onSuccess(response, 'Autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
